import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IThongKeSiSoActionTypes } from "../../action-types/thong-ke/IThongKeSiSoActions";
import { IThongKeSiSoReducer } from "../../page-state-model/thong-ke/IThongKeSiSoReducer";
const iniState: IThongKeSiSoReducer = {
    data: [],
    trangThai: [],
    filter: {
        dm_coso_id: 0,
        nam_hoc: ""
    },
    expandedIds: new Map<string, string>(),
    status: ePageBaseStatus.is_not_initialization
}
export const thongKeSiSoReducer = (
    state: IThongKeSiSoReducer = iniState,
    action: IThongKeSiSoActionTypes
): IThongKeSiSoReducer => {
    switch (action.type) {
        case "THONG_KE_SI_SO_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "THONG_KE_SI_SO_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THONG_KE_SI_SO_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: action.payload
            }
        case "THONG_KE_SI_SO_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THONG_KE_SI_SO_CHANGE_EXPANDED_IDS":
            return {
                ...state,
                expandedIds: action.payload,
            }
        case "THONG_KE_SI_SO_LOAD_TRANG_THAI_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THONG_KE_SI_SO_LOAD_TRANG_THAI_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                trangThai: action.payload
            }
        case "THONG_KE_SI_SO_LOAD_TRANG_THAI_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}